import React, { useEffect } from "react";
import { Form, Input, Button, Card, Row, Col, Image } from "antd";
import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  changePassword,
  getMyOrganization,
  getMyOrganizationClear,
  getMyOrganizationRequest,
  getReadingClear,
  getReadingListClear,
  getSubjectClear,
  getSubjectListClear,
  getUserListRequest,
  login,
  loginClear,
  loginRequest } from
"@src/redux";
import { retrieveItem, storeItem } from "@src/helpers/functions";
import { useNavigate } from "react-router-dom";
import { useForm } from "antd/es/form/Form";
import toast from "react-hot-toast";
import ChangePasswordModal from "../change-password/ChangePasswordModel";
import ForcePasswordChanges from "./ForcePasswordChanges";
import myRoutes from "@src/routes/MyRoutes";

type Props = {};
type Route = {
  path: string;
  name: string;
  component: any;
  authenticate: boolean;
  key: string;
  children?: Route[];
};
const LoginForm: React.FC<Props> = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [form] = useForm();

  const userId = retrieveItem("userId");

  const { result: passwordChangeResult, loading: passwordChangeLoading } =
  useSelector(changePassword);

  // useEffect(() => {

  // }, [dispatch]);

  const {
    result: loginResults,
    error: loginError,
    loading: loginLoading
  } = useSelector(login);

  // const onFinish = (values: any) => {
  //   dispatch(
  //     loginRequest({
  //       data: {
  //         username: values.code
  //           ? `${values.code}~${values?.username}`
  //           : values?.username,
  //         password: values?.password,
  //       },
  //     })
  //   );
  // };

  const onFinish = (values: any) => {
    dispatch(
      loginRequest({
        data: {
          username: values.code?.trim() ?
          `${values.code.trim()}~${values?.username?.trim()}` :
          values?.username?.trim(),
          password: values?.password?.trim()
        }
      })
    );
  };

  // useEffect(() => {
  //   if (password_change_result?.status === "success") {
  //     navigate("/login");
  //   }
  // }, [password_change_result]);

  const findPath = (
  routes: any[],
  targetKey: string,
  parentPath: string = "")
  : string | null => {
    for (const route of routes) {
      const fullPath = `${parentPath}/${route.path}`.replace(/\/+/g, "/");

      if (route.key === targetKey) {
        return fullPath;
      }

      if (route.children) {
        const childPath = findPath(route.children, targetKey, fullPath);
        if (childPath) {
          return childPath;
        }
      }
    }
    return null;
  };


  useEffect(() => {
    const forcePasswordChange =
      loginResults?.forcePasswordChange ?? loginResults?.forcePasswordChange;
    const sessionId = loginResults?.sessionId ?? loginResults?.sessionId;
    const userId = loginResults?.userId ?? loginResults?.userId;
    const pageAccesses =
      loginResults?.pageAccesses ?? loginResults?.pageAccesses;
    const pageComponentAccesses =
      loginResults?.pageComponentAccesses ??
      loginResults?.pageComponentAccesses;
    const homePage = loginResults?.homePage ?? loginResults?.homePage;
    const systemUser = loginResults?.systemUser;
    const redirectPath = findPath(myRoutes, homePage || "") || "/home";

    if (loginResults?.status === "success" && forcePasswordChange === false) {
      // Clear stale data from previous session to prevent race conditions
      // where old org/reading/subject data briefly renders before fresh data loads
      dispatch(getMyOrganizationClear());
      dispatch(getReadingClear());
      dispatch(getReadingListClear());
      dispatch(getSubjectClear());
      dispatch(getSubjectListClear());

      storeItem("sessionId", sessionId);
      storeItem("userId", userId);
      storeItem("pageAccesses", pageAccesses);
      storeItem("pageAccesses", pageAccesses);
      storeItem("has_NCD", loginResults?.hasNCD);
      storeItem("pageComponentAccesses", pageComponentAccesses);
      storeItem("pageComponentAccesses", pageComponentAccesses);
      storeItem("user", systemUser);
      storeItem("homePage", homePage);
      storeItem("homePage", homePage);
      storeItem("organizationId", loginResults.organizationId);
      dispatch(
        getUserListRequest({
          filter: {
            id: userId
          }
        })
      );
      navigate(redirectPath);
      form.resetFields();
      dispatch(loginClear());
    } else if (
    loginResults?.error?.message ||
    loginResults?.status === "failure")
    {
      toast.error(
        loginResults?.error?.message ?
        loginResults?.error?.message :
        "Invalid username and password"
      );
      dispatch(loginClear());
    }
  }, [loginResults, loginError]);

  return (
    <Card className="login_form_card">
      {loginResults &&
      loginResults.forcePasswordChange === true ?
      // ||
      // password_change_result?.status === "success"
      <ForcePasswordChanges /> :

      <Form
        name="loginForm"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        layout="vertical">
        
          <Form.Item label="Username">
            <Row gutter={8}>
              <Col span={6}>
                <Form.Item name="code" noStyle>
                  <Input placeholder="Code" className="login_form_input_code" />
                </Form.Item>
              </Col>
              <Col span={18}>
                <Form.Item name="username" noStyle>
                  <Input
                  placeholder="Username"
                  className="login_form_input_username" />
                
                </Form.Item>
              </Col>
            </Row>
          </Form.Item>

          <Form.Item
          name="password"
          label="Password"
          rules={[{ message: "Please input your password!" }]}>
          
            <Input.Password
            placeholder="Password"
            className="login_form_input_password" />
          
          </Form.Item>

          <Form.Item>
            <Button
            htmlType="submit"
            className="login_form_button"
            loading={loginLoading}>
            
              {t("sign_in")}
            </Button>
          </Form.Item>
        </Form>}
      
    </Card>);

};

export default LoginForm;